// extracted by mini-css-extract-plugin
module.exports = {"separator":"RegistrationStyles_separator__1-Bhw"};